import React from 'react'
import PropTypes from 'prop-types'
import Star from '!!@svgr/webpack!./star.svg'

function StarFraction({ fraction, last }) {
  let insetFraction = 1 - fraction
  switch (insetFraction) {
    // 25 percent of the width of the star feels very small so therefore
    // 25% and 75% is transformed to 35% and 65% respectively
    case 0.25:
      insetFraction = 0.35
      break
    case 0.75:
      insetFraction = 0.65
      break
    default:
      break
  }

  return (
    <div className={`relative ${last ? '' : 'pr-4'}`}>
      <Star
        className="block"
        style={{
          clipPath: `inset(0 ${insetFraction * 100}% 0 0)`,
          WebkitClipPath: `inset(0 ${insetFraction * 100}% 0 0)`,
        }}
      />
      <Star className="opacity-25 absolute top-0 block" />
    </div>
  )
}

StarFraction.propTypes = {
  fraction: PropTypes.number.isRequired,
  last: PropTypes.bool,
}

function StarRating({ rating, ...props }) {
  return (
    <div className="flex items-center" {...props}>
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <StarFraction
            key={index}
            fraction={Math.min(Math.max(rating - index, 0), 1)}
          />
        ))}
    </div>
  )
}

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
}

export default StarRating
